import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: ()=>import('@/components/Index')
    },
    {
      path: '/regist',
      name: 'regist',
      component: ()=>import('@/components/regist')
    },
    {
      path: '/load',
      name: 'download',
      component: ()=>import('@/components/download')
    },
    {
      path: '/love/:index/:img',
      name: 'love',
      props:true,
      component: ()=>import('@/components/LoveCar')
    },
    {
      path: '/about/:index/:img',
      name: 'about',
      props:true,
      component: ()=>import('@/components/About')
    },
    {
      path: '/good/:index/:img',
      name: 'good',
      props:true,
      component: ()=>import('@/components/GoodAngel')
    },
    {
      path: '/alliance/:index/:img',
      name: 'alliance',
      props:true,
      component: ()=>import('@/components/Alliance')
    },
    {
      path: '/service/:index/:img',
      name: 'service',
      props:true,
      component: ()=>import('@/components/Service')
    },
    {
      path: '/app',
      name: 'app',
      component: ()=>import('@/components/app')
    },
    {
      path: '/cycle',
      name: 'cycle',
      component: ()=>import('@/components/cycle')
    },
    {
      path: '/new',
      name: 'new',
      component: ()=>import('@/components/NewPerson')
    },
    {
      path: '/pabulum',
      name: 'pabulum',
      component: ()=>import('@/components/pabulum')
    },
    {
      path: '/share',
      name: 'share',
      component: ()=>import('@/components/share')
    },
    {
      path: '/green',
      name: 'green',
      component: ()=>import('@/components/GreenDriver')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js